// extracted by mini-css-extract-plugin
export default {"calendar-table-cell":"_1dP6WIR_0wPAGBubVhEcrS","calendar-table-cell--starts-week":"_12oObwDpCoHFJda9EwZhjL"};